import React from 'react';
import { ShoppingBag, ArrowRight } from 'lucide-react';
import { toast } from '../components/ui/sonner';

// Clickable "added to cart" toast — tapping it (anywhere except close button) navigates to /cart
export const showAddedToCartToast = (message, navigate) => {
  toast.custom(
    (id) => (
      <div
        className="cart-toast"
        data-testid="cart-toast"
        onClick={() => {
          toast.dismiss(id);
          navigate('/cart');
        }}
      >
        <ShoppingBag size={18} className="cart-toast-icon" />
        <span className="cart-toast-message">{message}</span>
        <ArrowRight size={16} className="cart-toast-arrow" />
      </div>
    ),
    { duration: 4000 }
  );
};
